import React from 'react'
import { Link } from 'react-router-dom'
import MdDirectionsRun from 'react-icons/lib/md/directions-run'
import { array, func } from 'prop-types'

import styles from './MobileSessionMenu.styl'

export default class MobileSessionMenu extends React.Component {

	static propTypes = {
		navigation: array,
		closeMenu: func
	}

	static defaultProps = {
		closeMenu: () => null
	}

	state = {
		isOpen: false,
		show: false
	}

	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}

	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}

	renderNavication(navigation = [], closeMenu) {
		return navigation.map((item, index) => {
			const { to, name, icon: Icon, action } = item
			const Element = to ? Link : 'div'
			const ElementProps = {
				to,
				onClick: action
			}
			return (
				<li
					key={ index }
					className={ styles['nav-entry'] }
					onClick={ () => { closeMenu() } }
					style={ { animationDelay: `${ (index * 100) + 250 }ms` } }
				>
					<Element { ...ElementProps } >
						{ Icon ? <Icon /> : null }{ name }
					</Element>
				</li>
			)
		})
	}
	render() {
		const { closeMenu, navigation } = this.props
		return (
			<div
				className={ styles['menu'] }
			>
				<div className={ styles['backdrop'] } />
				<div className={ styles['content'] }>
					<div className={ styles['nav'] }>
						<ul>
							<li
								className={ styles['nav-entry'] }
								onClick={ () => { closeMenu() } }
								style={ { animationDelay: '250ms' } }
							>
								<Link activeClassName={ styles['active'] } to="/apt/plans" className={ styles['profile'] }>
									<MdDirectionsRun />Planos
								</Link>
							</li>
							{ this.renderNavication(navigation, closeMenu) }
						</ul>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/MobileSessionMenu/MobileSessionMenu.js